import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

import InvestmentConfirmationModal from '../../../../../../components/common/modals/InvestmentConfirmationModal';
import { useNavigateByName } from '../../../../../../hooks';
import { RouteDictionary } from '../../../../../../utils';

const OfferConfirmation = () => {
  const { investmentUuid, confirmationUuid } = useParams();
  const navigate = useNavigateByName();
  const location = useLocation();

  if (!investmentUuid || !confirmationUuid) {
    return null;
  }

  const handleClose = () => {
    if (location.pathname.includes('/confirmation/')) {
      navigate(RouteDictionary.CREATE_OFFER, { investmentUuid });
    }
  };

  return (
    <InvestmentConfirmationModal active confirmationUuid={confirmationUuid} onClose={handleClose} />
  );
};

export default OfferConfirmation;
